import { useEffect, useState } from "react";
import "./TherapistProfile.css";

import { useSelector } from "react-redux";
import { selectUser } from "../../../../redux/features/userSlice";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { onValue, ref } from "firebase/database";
import { db } from "../../../../firebaseConfig";
import { Link, useParams } from "react-router-dom";

import EditIcon from "@mui/icons-material/Edit";
import EditTherapistBio from "./EditTherapistBio";

import Payment from "../payment/Payment";

export default function TherapistProfile() {
  const user = useSelector(selectUser);
  const { therapistUID } = useParams();
  // console.log(therapistUID);

  const [therapistData, setTherapistData] = useState({});
  const [calendlyLink, setCalendlyLink] = useState(
    "https://calendly.com/vibesandvent/20mins_consultation"
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    // Subscribe to real-time updates
    const starCountRef = ref(db, `therapists/${therapistUID}`);
    const unsubscribe = onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setTherapistData(data);
        setCalendlyLink(data.calendlyLink);
      }
    });
    // Cleanup the subscription on component unmount
    return () => {
      unsubscribe();
    };
  }, [therapistUID]);

  const [therapistsIDS, setTherapistsIDS] = useState([]);
  const [therapistIsTheUser, setTherapistIsTheUser] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Subscribe to real-time updates
    const starCountRef = ref(db, "therapists");
    const unsubscribe = onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        Object.values(data).map((item) => {
          if (item) {
            setTherapistsIDS((prev) => [...prev, item.uid]);
          }
        });
      }
    });
    // Cleanup the subscription on component unmount
    return () => {
      unsubscribe();
    };
  }, [user]);

  useEffect(() => {
    if (therapistsIDS.includes(user?.uid)) {
      setTherapistIsTheUser(true);
    } else {
      setTherapistIsTheUser(false);
    }
  }, [therapistsIDS, user?.uid]);

  let bioText = therapistData.bio || "";

  const [bioTextUpdate, setBioTextUpdate] = useState(bioText);
  const [isEditBio, setIsEditBio] = useState(false);
  const [isEnterMobileNumber, setEnterMobileNumber] = useState(false);

  const [bioTextLines, setBioTextLines] = useState([]);
  useEffect(() => {
    const bioTextArray = bioText?.split(".");
    const tempBioTextLines = [];

    for (let i = 0; i < bioTextArray.length; i += 3) {
      const group = bioTextArray.slice(i, i + 3).join(" ");
      if (i + 3 >= bioTextArray.length && group?.split(" ").length === 1) {
        continue; // Skip adding the last group if it contains only one string
      }
      tempBioTextLines.push(group);
    }
    setBioTextLines(tempBioTextLines);
  }, [bioText]);

  return (
    <>
      {isEnterMobileNumber ? (
        <Payment calendlyLink={calendlyLink} />
      ) : (
        <div className="therapist-profile">
          <div className="therapist-profile-container">
            <Link to={`/therapists`} className="back-button">
              <KeyboardBackspaceIcon className="back-button-icon" />
            </Link>
            <div className="therapist-top">
              <img
                alt={`${user?.displayName}`}
                src={therapistData?.photoURL || ""}
                className="therapist-profile-photo"
              />
              <h2>{therapistData.displayName}</h2>
              <h4>Therapist</h4>
              {!isEditBio &&
                (therapistUID === user?.uid ||
                  (process.env.REACT_APP_AUTHORIZED_EMAILS?.split(",").includes(
                    user?.email
                  ) &&
                    bioText.length > 0)) && (
                  <button
                    onClick={() => {
                      setIsEditBio(true);
                      setBioTextUpdate(bioText || "");
                    }}
                    className="edit-btn"
                  >
                    Edit Profile
                    <EditIcon className="edit-btn-icon" />
                  </button>
                )}
            </div>
            {bioTextLines.map((groupedlines, index) => (
              <h3 key={index}>{groupedlines}.</h3>
            ))}
          </div>
          {!therapistIsTheUser && (
            <button
              className="book-session"
              onClick={() => setEnterMobileNumber(true)}
            >
              Book a Session
            </button>
          )}
        </div>
      )}
      {isEditBio && (
        <EditTherapistBio
          setBioTextUpdate={setBioTextUpdate}
          bioTextUpdate={bioTextUpdate}
          therapistData={therapistData}
          setIsEditBio={setIsEditBio}
        />
      )}
    </>
  );
}
